var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39582 15.487C6.2974 15.487 6.19898 15.4523 6.11793 15.3886C5.53319 14.908 5.20898 14.138 5.20898 13.2175L5.20898 8.58594C5.20898 6.60594 5.97898 5.83594 7.95898 5.83594L11.4327 5.83594C12.6137 5.83594 13.8527 6.05594 14.119 7.70594C14.1595 7.94331 13.9974 8.16331 13.76 8.20383C13.5227 8.24436 13.3027 8.08225 13.2621 7.84489C13.1406 7.09225 12.8221 6.70436 11.4327 6.70436L7.95898 6.70436C6.4653 6.70436 6.0774 7.09225 6.0774 8.58594L6.0774 13.2175C6.0774 13.5938 6.15267 14.2944 6.66793 14.717C6.85319 14.8675 6.88214 15.1454 6.72582 15.3307C6.64477 15.4349 6.5174 15.487 6.39582 15.487Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4325 15.9657L8.53772 15.9657C8.30036 15.9657 8.10351 15.7688 8.10351 15.5315C8.10351 15.2941 8.30036 15.0972 8.53773 15.0972L11.4325 15.0972C12.9261 15.0972 13.314 14.7094 13.314 13.2157L13.314 10.3209C13.314 10.0836 13.5109 9.88672 13.7483 9.88672C13.9856 9.88672 14.1825 10.0836 14.1825 10.3209L14.1825 13.2157C14.1825 15.1957 13.4125 15.9657 11.4325 15.9657Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9477 14.4C15.6988 14.4 15.3919 14.319 15.0272 14.0642L13.4988 12.9932C13.3019 12.8542 13.2556 12.5821 13.3945 12.3911C13.5335 12.1942 13.7998 12.1479 13.9967 12.2869L15.5251 13.3579C15.7798 13.5374 15.9651 13.5547 16.0403 13.5142C16.1156 13.4737 16.2082 13.3174 16.2082 13.0047L16.2082 8.00843C16.2082 7.77106 16.4051 7.57422 16.6424 7.57422C16.8798 7.57422 17.0767 7.77106 17.0767 8.00843L17.0767 12.999C17.0767 13.8269 16.6772 14.1568 16.4398 14.2784C16.3298 14.3363 16.1619 14.4 15.9477 14.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99612 18.5722C3.86306 18.5722 3.73001 18.5231 3.62497 18.4181C3.42188 18.2151 3.42188 17.879 3.62497 17.6759L17.6307 3.67183C17.8338 3.46877 18.1699 3.46877 18.373 3.67183C18.5761 3.87489 18.5761 4.21099 18.373 4.41404L4.36727 18.4181C4.26923 18.5231 4.12917 18.5722 3.99612 18.5722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopVideoIcon);
export default __webpack_public_path__ + "static/media/stopVideo_icon.7f32ee8d950f84606ca0c8534cec355c.svg";
export { ForwardRef as ReactComponent };